import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Rollo } from '../models';
import { environment } from 'src/environments/environment';
import PouchDB from 'pouchdb-browser';
import { from, Subject } from 'rxjs';
import {RequestSaveRollo, RequestSendPush} from '../models/request';

@Injectable({
  providedIn: 'root'
})
export class RolloService {
  private db: any;
  counterDocs$ = new Subject<number>();
  actualCount = 0;

  private ENDPOINT = environment.ENDPOINTS.MORRALLA;
  private ENDPOINT_ROLLO = environment.ENDPOINTS.ROLLO;
  constructor(private http: HttpClient) {
    this.db = new PouchDB('db_rollo');
    this.getInfoLocal();
  }

  saveRollo(rollo) {
    return this.http.post<Rollo>(this.ENDPOINT_ROLLO, rollo);
  }


  saveUltimoFolio(rollo) {
    let idCarril  = localStorage.getItem("id_carril");
    return this.http.post<Rollo>(`${this.ENDPOINT_ROLLO}/save/ultimo-folio`, {...rollo, id_carril : idCarril });
  }

  updateCorteToControlFolio(rollo) {
    return this.http.post<Rollo>(`${this.ENDPOINT_ROLLO}/update/corte-to-control-folio`,rollo);
  }

  getRollo() {
    return this.http.get<Rollo[]>(this.ENDPOINT);
  }

  getUltimoFolio(){
    let idCarril = localStorage.getItem("id_carril");
    return this.http.get(`${this.ENDPOINT_ROLLO}/get/ultimo-folio?id_carril=${idCarril}`);
  }

  updateFolios(rollo) {
    return this.http.post<any>(`${this.ENDPOINT_ROLLO}/update/folio-from-jt`, rollo);
  }

  public saveRolloLocal = (dataSchema: Rollo) => {
    console.log('no hay conexión a red');
    let result: Promise<Rollo> = new Promise((resolve, reject) => {
      this.db.get(dataSchema._id)
        .then(async (doc: any) => {
          console.log('encontrado y actualizado')
          delete dataSchema._id;
          doc = Object.assign(doc, dataSchema);
          try{
            let result =  await this.db.put(doc);
            resolve(result);
          }catch(err){
            reject(err)
          }

        }).catch(async () => {
          try{
            let result = await this.db.post(dataSchema)
            resolve(result);
            console.log('se creo new register')
            this.actualCount = this.actualCount + 1;
            console.log(this.actualCount)
            this.counterDocs$.next(this.actualCount)
          }catch(err){
            reject(err);
          }

        });
    })

    return from(result);

  }

  public deleteRolloLocal(id: number) {
    return this.db.get(id)
      .then(doc => {
        return this.db.remove(doc);
      })
      .then(
        _ => {
          this.actualCount = this.actualCount - 1;
          console.log(this.actualCount)
          this.counterDocs$.next(this.actualCount)
          return true;
        }
      )
      .catch(err => {
        console.log(err)
      })
  }
  public getInfoLocal() {
    this.db.info().then(data => {
      this.actualCount = data.doc_count;
      console.log(this.actualCount)
      this.counterDocs$.next(this.actualCount);
    });
  }


  public getAll(): Promise<Rollo[]> {
    return new Promise((resolve, reject) => {
      this.db.allDocs({
        include_docs: true
      })
        .then(data => {
          let eventsRollo = data.rows.map(
            (row: any): Rollo => {

              return ({
                _id: row.doc._id,
                folio_final: row.doc.folio_final,
                folio_inicial: row.doc.folio_inicial,//nuevo folio
                id_corte_usuario: row.doc.id_corte_usuario,

              });

            }
          )
          resolve(eventsRollo);
        }).catch(err => {
          reject(err)
        })
    })
  }

}
